export enum SalesOrderTabsEnum {
  POSITIONS = 'positions',
  DELIVERY_INFORMATION = 'delivery-information',
  BILLING_INFORMATION = 'billing-information',
  PREFERENCES = 'preferences',
  DOCUMENTS = 'documents',
}
